module.exports = __webpack_public_path__ + "img/9.96429de8.jpg";